export default __webpack_public_path__ + "static/media/showerRain.0eda34ee.jpg";